<template>
  <div class="c-number-range">
    <Input v-model="start" number :placeholder="startPlaceholder" :style="styles" @on-blur="updatedBlur" />
    <span>&nbsp; — &nbsp;</span>
    <Input v-model="end" number :placeholder="endPlaceholder" :style="styles" @on-blur="updatedBlur" />
  </div>
</template>
<script>
import { mul, div } from '@/common/js/api'
import { isArray, isEmpty } from '@/common/js/utils'
export default {
  name: 'inputRange',
  props: {
    value: {
      type: [Array, String],
      required: true
    },
    precision: {
      type: Number,
      default: 0
    },
    step: {
      type: Number
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 100
    },
    placeholder: {
      type: String,
      default: '数量'
    }
  },
  computed: {
    start: {
      get() {
        const [min] = isArray(this.value) ? this.value : this.value.split(',')
        return min || ''
      },
      set(val) {
        this.$emit('input', [val, this.end])
      }
    },
    end: {
      get() {
        const [, max] = isArray(this.value) ? this.value : this.value.split(',')
        return max || ''
      },
      set(val) {
        this.$emit('input', [this.start, val])
      }
    },
    styles() {
      return { width: '76px' }
    },
    startPlaceholder() {
      return `起始${this.placeholder}`
    },
    endPlaceholder() {
      return `结束${this.placeholder}`
    }
  },
  methods: {
    fmtNumber(val) {
      if (!isEmpty(val) && this.precision) {
        // 小数位
        val = parseFloat(val)
        val = parseInt(mul(val, Math.pow(10, this.precision)))
        val = div(val, Math.pow(10, this.precision))
      } else if (!isEmpty(val)) val = parseInt(val)
      return val
    },
    updatedBlur() {
      const [min, max] = isArray(this.value) ? this.value : this.value.split(',')
      let val = [this.fmtNumber(min), this.fmtNumber(max)]

      if (!isEmpty(min) && min < this.min) {
        this.$Message.warning(`${this.placeholder}区间不能小于${this.min}`)
        val = [this.min, max]
      } else if (!isEmpty(min) && min > this.max) {
        this.$Message.warning(`${this.placeholder}区间不能大于${this.max}`)
        val = [this.max, max]
      }

      if (!isEmpty(max) && max < this.min) {
        this.$Message.warning(`${this.placeholder}区间不能小于${this.min}`)
        val = [min, this.min]
      } else if (!isEmpty(max) && max > this.max) {
        this.$Message.warning(`${this.placeholder}区间不能大于${this.max}`)
        val = [min, this.max]
      }

      if (!isEmpty(min) && !isEmpty(max) && min > max) {
        this.$Message.warning(`${this.placeholder}区间不能首比尾大`)
        val = [min, '']
      }

      if (!isEmpty(val[0]) && !isEmpty(val[1]) && val[0] === val[1]) {
        this.$Message.warning(`${this.placeholder}区间不能首尾相同`)
        val = [min, '']
      }

      if (!isEmpty(val[0]) && !isEmpty(val[1]) && this.step && val[1] - val[0] > this.step) {
        this.$Message.warning(`${this.placeholder}区间不能相差${this.step}`)
        val = [min, '']
      }

      this.$emit('input', val)
    }
  },
  watch: {
    value: {
      handler(nVal) {},
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
.c-number-range {
  display: inline-block;
}
</style>
